import React, { useRef, useEffect, useState } from 'react';
import { BaseButton, useT } from '@repo/common';

import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

function CareerList({
  onSelect,
  selectedOption,
  isMyPagePersonalInfo = false,
}) {
  const t = useT();
  const CAREER_OPTIONS = [
    {
      value: 'Select Career level',
      label: 'Select Career level',
      labelKr: '경력 수준 선택',
    },
    { value: 'Entry', label: 'Entry (0 yrs)', labelKr: '신입 (0년)' },
    { value: '1 yrs', label: '1 yrs', labelKr: '1년' },
    { value: '2 yrs', label: '2 yrs', labelKr: '2년' },
    { value: '3 yrs', label: '3 yrs', labelKr: '3년' },
    { value: '4 yrs', label: '4 yrs', labelKr: '4년' },
    { value: '5 yrs', label: '5 yrs', labelKr: '5년' },
    { value: '6 yrs', label: '6 yrs', labelKr: '6년' },
    { value: '7 yrs', label: '7 yrs', labelKr: '7년' },
    { value: '8+ yrs', label: '8+ yrs', labelKr: '8년 이상' },
  ];

  const listRef = useRef(null);
  const selectedRef = useRef(null);
  const [localSelected, setLocalSelected] = useState(selectedOption);

  useEffect(() => {
    const c = listRef.current;
    const s = selectedRef.current;
    if (c && s) c.scrollTop = s.offsetTop - 8;
  }, [selectedOption]);

  useEffect(() => {
    setLocalSelected(selectedOption);
  }, [selectedOption]);

  return (
    <div
      ref={listRef}
      className={`relative shrink-0 w-full ${isMyPagePersonalInfo ? 'h-[206px]' : 'h-[244px]'} overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {CAREER_OPTIONS.map((option) => {
          const isSelected = option.value === localSelected;

          return (
            <div
              key={option.value}
              ref={isSelected ? selectedRef : null}
              className='flex items-center rounded-lg transition-colors duration-150'
            >
              <BaseButton
                type='text'
                size='m'
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onClick={(e) => {
                  e.stopPropagation();
                  setLocalSelected(option.value);
                  onSelect(option.value);
                }}
                leftalign='true'
                icon={
                  isSelected ? (
                    <CheckIcon className='text-icon-primary' />
                  ) : (
                    <span className='w-4 h-[18px]' />
                  )
                }
              >
                {t(option.label, option.labelKr)}
              </BaseButton>
            </div>
          );
        })}
      </ul>
    </div>
  );
}

export default CareerList;
